module.exports = __webpack_public_path__ + "static/media/info.ec72b9ae.svg";